import {GeneratedType} from "@shareledgerjs/signing";

export function createTxTypes(): ReadonlyArray<[string, GeneratedType]> {
  return [];
}
